import { useState } from "react";

import { Box, Typography } from "@mui/material";
import { Button, Modal } from "@covertree/ui";

interface DiscardEndorsementModalProps {
  readonly isModalOpen: boolean;
  readonly onClose: () => void;
  onConfirm: () => Promise<void>;
}

export function DiscardEndorsementModal({
  isModalOpen,
  onClose,
  onConfirm,
}: DiscardEndorsementModalProps) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal
      disableClose={isLoading}
      open={isModalOpen}
      onClose={onClose}
      title="Are you sure?"
      maxWidth="sm">
      <Typography color={"gray"} variant="body2">
        Do you want to discard this endorsement? This action cannot be undone.
      </Typography>
      <Box mt={4} columnGap={3} display="flex" justifyContent="flex-start">
        <Button
          loading={isLoading}
          disabled={isLoading}
          onClick={handleConfirm}
          color="error">
          Yes, discard
        </Button>
        <Button disabled={isLoading} onClick={onClose} variant="outlined">
          No, cancel
        </Button>
      </Box>
    </Modal>
  );
}

export default DiscardEndorsementModal;
